import * as React from 'react';
import { cloudProviders, Providers } from 'portal-shared-lib';
import { Provider } from '../models/filespace/provider';
import awsImgUrl from 'src/webportal/theme/images/aws.png';
import azureSmallImgUrl from 'src/webportal/theme/images/azure-small.png';
import gcpImgUrl from 'src/webportal/theme/images/gcp.png';
import ibmImgUrl from 'src/webportal/theme/images/ibm.png';
import zadaraImgUrl from 'src/webportal/theme/images/zadara.png';
import cloudianImgUrl from 'src/webportal/theme/images/cloudian.png';
import scalityImgUrl from 'src/webportal/theme/images/scality.jpg';
import telefonicaImgUrl from 'src/webportal/theme/images/telefonica.jpg';
import wasabiImgUrl from 'src/webportal/theme/images/wasabi.png';
import nutanixImgUrl from 'src/webportal/theme/images/nutanix-logo.png';
import dellImgUrl from 'src/webportal/theme/images/dell.png';
import backblazeImgUrl from 'src/webportal/theme/images/backblaze.png';
import alibabaImgUrl from 'src/webportal/theme/images/alibaba.png';
import digitaloceanImgUrl from 'src/webportal/theme/images/digitalocean-logo.png';
import exoscaleImgUrl from 'src/webportal/theme/images/exoscale-logo.png';
import pureImgUrl from 'src/webportal/theme/images/pure.png';
import otherImgUrl from 'src/webportal/theme/images/other.png';
import { loadStripe } from '@stripe/stripe-js';

export const version = process.env.REACT_APP_VERSION;
export const productType = process.env.REACT_APP_PRODUCT;
// stripe variables
export const stripePk = process.env.REACT_APP_STRIPE_PK || 'pk_test_Wrc04BDdvjfvLmvCLVz9K0Oj';

// cognito variables
export const redirectURI = process.env.REACT_APP_REDIRECT_URI || 'https://webportal-be.lucidlink.com/webportal';
export const region = process.env.REACT_APP_COGNITO_REGION || 'eu-central-1';
export const userPoolId = process.env.REACT_APP_USER_POOL_ID || 'eu-central-1_wli1laX8M';
export const clientId = process.env.REACT_APP_CLIENT_ID || '6dvunmcn887j0fclmdredjgqd7';
export const identityPoolId = process.env.REACT_APP_IDENTITY_POOL_ID || 'eu-central-1:36550a85-bae8-4749-940f-c1d074b8ac8d';
export const appWebDomain = process.env.REACT_APP_APP_WEB_DOMAIN || 'lucid-staging';
export const amplitudeKey = process.env.REACT_APP_AMPLITUDE_KEY || '9b5af426549b11f7b9c60d5e5ce93561';

export const stripePromise = loadStripe(stripePk);
export const experimentalSettingsEnabled = process.env.REACT_APP_EXPERIMENTAL_FEATURES_ENABLED ?
    process.env.REACT_APP_EXPERIMENTAL_FEATURES_ENABLED.split(',') :
    null;

export const DEFALT_LOADING_ICON_SIZE = 80;
export const MAX_EMAIL_STRING_LENGTH = 15;

export enum StepNames {
    Name = 'Name',
    Plan = 'Plan',
    CloudProvider = 'Cloud Provider',
    Region = 'Region',
    Endpoint = 'Endpoint',
    AdvancedSettings = 'Advanced settings',
    Confirm = 'Confirm',
}

export const DEFAULT_FS_STEPS = [StepNames.Name, StepNames.Plan, StepNames.CloudProvider, StepNames.Region, StepNames.Confirm];

const identityProviders = [
    { name: 'Facebook', providerId: 'Facebook' },
    { name: 'Amazon', providerId: 'LoginWithAmazon' }
];

export const signUpSites = identityProviders.map(identityProvider => {
    const urlQueryParameters = new URLSearchParams(window.location.search);

    return {
        name: identityProvider.name,
        component: (onClick: Function) => {
            return <a href="#" onClick={(e: any) => {e.preventDefault(); onClick(identityProvider.providerId, urlQueryParameters); }}>{identityProvider.name}</a>;
        }
    };
});

export const TOTAL_DOM_FS_ALLOWED_SYMBOLS = 63;
export const DOMAIN_MIN_ALLOWED_SYMBOLS = 3;
export const FILESPACE_MIN_ALLOWED_SYMBOLS = 2;
export const BUCKET_MIN_ALLOWED_SYMBOLS = 3;

export const providers: Provider[] = [
    new Provider(cloudProviders[Providers.AWS], awsImgUrl),
    new Provider(cloudProviders[Providers.AWSGovCloud], awsImgUrl),
    new Provider(cloudProviders[Providers.Azure], azureSmallImgUrl),
    new Provider(cloudProviders[Providers.GCP], gcpImgUrl),
    new Provider(cloudProviders[Providers.IBM], ibmImgUrl),
    new Provider(cloudProviders[Providers.Zadara], zadaraImgUrl),
    new Provider(cloudProviders[Providers.Cloudian], cloudianImgUrl),
    new Provider(cloudProviders[Providers.Scality], scalityImgUrl),
    new Provider(cloudProviders[Providers.Telefonica], telefonicaImgUrl),
    new Provider(cloudProviders[Providers.Wasabi], wasabiImgUrl),
    new Provider(cloudProviders[Providers.Nutanix], nutanixImgUrl),
    new Provider(cloudProviders[Providers.Dell], dellImgUrl),
    new Provider(cloudProviders[Providers.Backblaze], backblazeImgUrl),
    new Provider(cloudProviders[Providers.Alibaba], alibabaImgUrl),
    new Provider(cloudProviders[Providers.DigitalOcean], digitaloceanImgUrl),
    new Provider(cloudProviders[Providers.Exoscale], exoscaleImgUrl),
    new Provider(cloudProviders[Providers.Pure], pureImgUrl),
    new Provider(cloudProviders[Providers.Other], otherImgUrl),
];

export const hostExpression = new RegExp('^(https?://)(www\\.)?([-a-z0-9]{1,63}\\.)*?[a-z0-9][-a-z0-9]{0,61}[a-z0-9]\\.[a-z]{2,6}(/[-\\w@\\+\\.~#\\?&/=%]*)?(:[0-9]{2,4})?$');
export const httpsRegex = /^(https?):\/\/(.*)/;

export const suspendedErrorTitle = 'Your account is suspended';
export const suspendedErrorMessage = 'Please revise your billing information and pay any outstanding invoices to restore your account.';

export const RETURN_ROUTE_PARAMETER_NAME = 'returnroute';

export const HTTP_STATUS_PAYMENT_NEEDED = 402;

export const IS_BLEEDING_EDGE = process.env.REACT_APP_ENV_NAME !== 'production';

export const V6_FILESPACE_RELEASE_DATE = 1676980800000;
export const PASSWORD_INVALID_DEFAULT_ERROR_MESSAGE = 'Your password must be at least 8 characters and  ' +
    'contain an uppercase letter, a lowercase letter, a number and a special character.';
export const DEFAULT_DIGIT_INPUT_COUNT = 6;
export const MIN_PASSWORD_LENGTH = 8;
export const DEFAULT_ERROR_MESSAGE = 'Something went wrong. Please try again later';

export const EMAIL_INVALID_DEFAULT_MESSAGE = 'Email address is invalid';

export const GOOGLE_IDENTITY_PROVIDER = 'Google';
export const FACEBOOK_IDENTITY_PROVIDER = 'Facebook';
export const AMAZON_IDENTITY_PROVIDER = 'Amazon';

export const LUCIDLINK_WEBSITE = 'https://www.lucidlink.com';

export const DONT_HAVE_AN_ACCOUNT_YET_MESSAGE = `Don't have an account yet?`;
export const I_ALREADY_HAVE_AN_ACCOUNT_MESSAGE = 'I already have an account.';

export const SIGN_IN_MESSAGE = 'Sign in (LucidLink Classic)';
export const SIGN_UP_MESSAGE = 'Create an account (LucidLink Classic)';

export const SESSION_STORAGE_EMAIL = 'll-wordpress-signup-block-email';
export const UNCONFIRMED_USER_SESSION_STORAGE_KEY = 'unconfirmedUser';



// WEBPACK FOOTER //
// ./src/webportal/utils/constants.tsx